import PropTypes from 'prop-types';

const DelimitedList = ({
  listItems,
  orientation = 'vertical',
  delimiter = '',
}) => {
  let classes = [];
  orientation === 'vertical' || classes.push('flex');
  if (delimiter === 'comma') classes.push('commaSeparated');
  else if (delimiter === 'pipe') classes.push('pipeSeparated');
  else classes.push('spaceSeparated');

  return (
    <div id='delimitedList' className={classes.join(' ')}>
      {listItems?.map((item, index) => {
        return <div key={index}>{item}</div>;
      })}
    </div>
  );
};

DelimitedList.propTypes = {
  listItems: PropTypes.array.isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  delimiter: PropTypes.oneOf(['default', 'comma', 'pipe']),
};

export default DelimitedList;
